import { contentChild, Directive, input, output } from '@angular/core';

import { AccordionContentDirective } from './accordion-content.directive';
import { AccordionHeaderDirective } from './accordion-header.directive';

@Directive({
  standalone: true,
  selector: '[b2cAccordionItem]',
})
export class AccordionItemDirective {
  title = input<string>('');
  disabled = input<boolean>(false);

  content = contentChild.required<AccordionContentDirective>(
    AccordionContentDirective
  );
  customHeader = contentChild.required<AccordionHeaderDirective>(
    AccordionHeaderDirective
  );

  readonly isExpanded = output<boolean>();
}
